import { render, staticRenderFns } from "./ChangePasswordPopup.vue?vue&type=template&id=7ac7aa4d&"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac7aa4d')) {
      api.createRecord('7ac7aa4d', component.options)
    } else {
      api.reload('7ac7aa4d', component.options)
    }
    module.hot.accept("./ChangePasswordPopup.vue?vue&type=template&id=7ac7aa4d&", function () {
      api.rerender('7ac7aa4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChangePasswordPopup.vue"
export default component.exports